import React from "react";
import { ShieldAlert } from "lucide-react";

/**
 * AdminLogin — landing page for /admin/login.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
const REASON_MESSAGES = {
  idle: "You were signed out due to inactivity. Please sign in again to continue.",
  session_cap: "Your session reached its maximum length. Please sign in again to continue.",
};

const AdminLogin = () => {
  const reason = new URLSearchParams(window.location.search).get("reason");
  const notice = REASON_MESSAGES[reason];

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <section
      className="min-h-[80vh] ek-gradient-dark text-white relative overflow-hidden flex items-center"
      data-testid="admin-login-page"
    >
      <div className="ek-star-watermark" />
      <div className="ek-vignette-top" />
      <div className="ek-container relative z-10 py-20">
        <div className="max-w-xl">
          {notice && (
            <div className="flex items-start gap-2 bg-amber-500/15 border border-amber-400/40 text-amber-100 px-4 py-3 mb-6 text-[14px]" data-testid="admin-login-timeout-notice">
              <ShieldAlert size={18} className="shrink-0 mt-0.5" />
              <span>{notice}</span>
            </div>
          )}
          <div className="ek-eyebrow text-[#A179FA]">Admin</div>
          <h1 className="ek-heading text-4xl md:text-5xl mt-4">Sign in to the Ekselens admin.</h1>
          <p className="text-zinc-300 font-light text-lg mt-6">
            Access is restricted to the authorised Ekselens administrator. Sign in with the
            allowlisted Google account to view contact submissions, brochure downloads,
            resource leads and manage the resource library and internal toolkits.
          </p>
          <button
            type="button"
            onClick={handleLogin}
            className="ek-btn ek-btn-primary mt-10"
            data-testid="admin-login-google-btn"
          >
            Sign in with Google
          </button>
          <p className="text-zinc-400 text-sm mt-6">
            By signing in you agree to the Ekselens admin terms. For security, sessions sign out after 30 minutes of inactivity and at most 12 hours.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AdminLogin;
